export type VoiceKey = "Puck" | "Charon" | "Kore" | "Fenrir" | "Aoede" | "Leda" | "Orus" | "Zephyr";

// Voices available to all users (free tier)
export const FREE_VOICES: ReadonlyArray<VoiceKey> = ["Aoede", "Puck", "Charon", "Fenrir"];

export const VOICE_DISPLAY_NAMES: Record<VoiceKey, string> = {
  Puck: "Mr. Joshua",
  Charon: "Mr. Ethan",
  Kore: "Ms. Sam",
  Fenrir: "Mr. Bryan",
  Aoede: "Mrs. Phoebe",
  Leda: "Ms. Joanna",
  Orus: "Prof. Markus",
  Zephyr: "Ms. Lisa",
};

// Voices available only to subscribed (premium) users
export const PREMIUM_VOICES: ReadonlyArray<VoiceKey> = (
  Object.keys(VOICE_DISPLAY_NAMES) as VoiceKey[]
).filter((key) => !FREE_VOICES.includes(key));

export const VOICE_DESCRIPTIONS: Record<VoiceKey, string> = {
  Zephyr: "Bright, Higher Pitch",
  Puck: "Upbeat, Middle Pitch",
  Charon: "Informative, Lower Pitch",
  Kore: "Firm, Middle Pitch",
  Fenrir: "Excitable, Lower Middle Pitch",
  Leda: "Youthful, Higher Pitch",
  Orus: "Firm, Lower Middle Pitch",
  Aoede: "Breezy, Middle Pitch",
};
